import React from 'react';
import RatingClassContainer from '../../Componant/Bonus-Ui/Rating';

const RatingClass = () => {
  return (
    <div className='page-body'>
      <RatingClassContainer />
    </div>
  );
};

export default RatingClass;
